
import { SessionController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Editing UI of Contact information for account.
 * @example
 * ```html
 * <salaxy-account-contact-edit></salaxy-account-contact-edit>
 * ```
 */
export class AccountContactEdit extends ComponentBase {
    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {};

    /** Uses the SessionController */
    public controller = SessionController;

    /** The default template for the component. */
    public defaultTemplate =  "salaxy-components/account/AccountContactEdit.html";

}
